// You can choose any icon from this list: https://react-icons.github.io/react-icons
import {
  FaAngleDown,
  FaCommentDots,
  FaEnvelope,
  FaInstagram
} from 'react-icons/fa';

import {
  SiShopee
} from "react-icons/si";

// This is the color list you can use for now: https://mui.com/material-ui/customization/color/
import {
  lime,
  pink
} from '@mui/material/colors';

import Youtube from './components/Youtube'

// @TODO: Create colorset for light and dark modes.
// @TODO: Properly use button and icon colors or maybe even ditch out
const colors = {
  "mode": "light",
  "primary": pink,
  "secondary": lime,
  "button": pink,
  "icon": pink,
}

const routes = {
  "sourcecode": "https://gitlab.com/osouza.de/bah-link-tri",
  "instagram": "https://www.instagram.com/geekybunnybr?igsh=MWs5b3U1bnVzN2Uxbg==",
  "shopee": "https://shopee.com.br/brunatw",
  "email": "mailto:contato@geeky-bunny.com"
}

const icons = [
  {
    "tooltip": "Nosso insta!",
    "icon": <FaInstagram />,
    "route": "instagram"
  },
  {
    "tooltip": "Loja na Shopee",
    "icon": <SiShopee />,
    "route": "shopee"
  },
  {
    "tooltip": "Send me a e-mail!",
    "icon": <FaEnvelope />,
    "route": "email",
  },
]

const items = [
  {
    "title": "Quem Somos? | Who Are We?",
    "content": "<p>Somos a Geeky-Bunny.<br />Uma loja de artesanato em crochê para os apaixonados pelo universo geek! Criamos personagens, mascotes e referências da cultura ''nerd'' em peças feitas à mão, cheias de personalidade e carinho. Confira nosso trabalho nos links abaixo!<br />-<br />We are Geeky-Bunny.<br />A crochet craft store for those who are passionate about the geek universe! We create characters, mascots, and pop culture references in handmade pieces, filled with personality and care. Check out our work through the links below!<br  /p><br/><small style='font-style:italic; float: right'>Allons-y!</small><br/>",
    "icon": <FaAngleDown />,
    "type": "accordion",
    "expanded": true
  },
  {
    "title": "Instagram",
    "content": "Instagram",
    "icon": <FaInstagram />,
    "route": "instagram",
    "type": "link",
    "hidden": false
  },
  {
    "title": "Shopee",
    "content": "Shopee",
    "icon": <SiShopee />,
    "route": "shopee",
    "type": "link"
  },
  {
    "title": "//extra",
    "content": "<iframe width='100%' src='https://www.youtube-nocookie.com/embed/dQw4w9WgXcQ?controls=0' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>",
    "icon": <FaAngleDown />,
    "type": "accordion",
    "hidden": true
  },
  {
    "title": "Listen (look) at this",
    "content": <Youtube embedId="dQw4w9WgXcQ?controls=0" />,
    "type": "popup",
    "hidden": true
  }
]

const config = {
  "avatar": "https://down-tx-br.img.susercontent.com/br-11134216-7r98o-m5ovwcswv7aqa6_tn.webp",
  "title": "Geeky-Bunny",
  colors,
  icons,
  items,
  routes
}

export default config
